import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'
import { Stack } from 'react-bootstrap'

export interface TemplateEditorHeaderProps {
  templateName?: string
}

export const TemplateEditorHeader: React.FC<TemplateEditorHeaderProps> = ({ templateName }) => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    navigate(-1)
  }

  return (
    <div className='d-flex align-items-center justify-content-between zocks-pl-2.0 zocks-gap-2 zocks-pr-2.0'>
      <div className='d-flex gap-3 align-items-center'>
        <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
          <i className='bi bi-chevron-left' />
        </Button>
        <Stack className='d-flex justify-content-center'>
          <span className='paragraph-extra-small bold text-uppercase zocks-text-gray-600'>Edit template</span>
          {templateName && <span className='paragraph-medium bold'>{templateName}</span>}
        </Stack>
      </div>
    </div>
  )
}
